/**
 * @desc 判断是否显示新增按钮
 * @param metaTreeNodes
 * @param areaId
 * @return boolean true -> 显示
 */
export function judgeAddCardMenuShow(metaTreeNodes, areaId) {
	if (metaTreeNodes.length === 0) {
		return  false
	}

	let { targetAreaID } = metaTreeNodes[0].props.dataRef;

	if (targetAreaID === areaId) {
		return  true
	}
}
